<adapt-confirmation-dialog (closed)="onDialogClosed($event)"
                           (initialised)="onInitialised($event)">
    <span>The following objective will be deleted:</span>
    <adapt-link-objective class="ms-3 mt-2"
                          [objective]="objective"
                          [generateHref]="false"></adapt-link-objective>

    @if (hasRelatedDeletion) {
        <div class="mt-3">
            <p class="mb-1">This includes the following:</p>
            <ul>
                @if (objective.hasKeyResults) {
                    <li>{{ objective.keyResults.length }} key results for this objective and their corresponding values</li>
                }
                @if (linkService.filterForObjectiveToObjectiveLinks(objective.links).length; as linkCount) {
                    <li>{{ linkCount }} objective links related to this objective</li>
                }
                @if (linkService.filterForObjectiveItemLinks(objective.links).length; as linkCount) {
                    <li>{{ linkCount }} item links related to this objective</li>
                }
            </ul>
        </div>
    }
    @if (objective.childObjectives.length > 0) {
        <div class="mt-3">
            <p class="mb-1">The following supporting objectives will no longer support this objective:</p>
            <ul>
                @for (child of objective.childObjectives; track child) {
                    <li class="d-flex">
                        <adapt-link-objective [objective]="child"
                                              [generateHref]="false"></adapt-link-objective>
                    </li>
                }
            </ul>
        </div>
    }
    <p class="mt-3">Are you sure you want to delete?</p>
</adapt-confirmation-dialog>
